// Updates "— X" selected-value labels when variant radio buttons change.
// Works alongside Dawn's variant-radios custom element.
(function () {
  'use strict';

  /* ── Thumbnail strip vertical scroll arrows ─────────────────────────── */
  (function () {
    var UP = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 7L5 3L8.5 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var DN = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3L5 7L8.5 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function initStrip(strip) {
      var list = strip.querySelector('.thumbnail-list');
      if (!list || strip.dataset.ergoArrows) return;
      strip.dataset.ergoArrows = '1';

      var up = document.createElement('button');
      up.type = 'button';
      up.className = 'ergo-thumb-arrow ergo-thumb-arrow--up';
      up.setAttribute('aria-label', 'Scroll thumbnails up');
      up.innerHTML = UP;

      var dn = document.createElement('button');
      dn.type = 'button';
      dn.className = 'ergo-thumb-arrow ergo-thumb-arrow--down';
      dn.setAttribute('aria-label', 'Scroll thumbnails down');
      dn.innerHTML = DN;

      strip.appendChild(up);
      strip.appendChild(dn);

      function update() {
        var st = list.scrollTop;
        var max = list.scrollHeight - list.clientHeight;
        up.classList.toggle('is-visible', st > 2);
        dn.classList.toggle('is-visible', max > 2 && st < max - 2);
      }

      function scrollStep(dir) {
        var item = list.firstElementChild;
        var step = item ? item.offsetHeight + 8 : 88;
        list.scrollBy({ top: dir * step, behavior: 'smooth' });
      }

      up.addEventListener('click', function () { scrollStep(-1); });
      dn.addEventListener('click', function () { scrollStep(1); });
      list.addEventListener('scroll', update, { passive: true });

      var ro = new ResizeObserver(update);
      ro.observe(list);
      update();
    }

    function initAll() {
      document.querySelectorAll('.ergo-media-col-layout > .thumbnail-slider').forEach(initStrip);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  /* ── End thumbnail scroll arrows ─────────────────────────────────────── */

  function updateLabels(container) {
    container.querySelectorAll('.ergo-swatch__fieldset').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var span = fieldset.querySelector('.ergo-swatch__selected');
      if (span) {
        span.textContent = checked ? ' — ' + checked.value : '';
      }
    });
  }

  function attachToContainer(container) {
    updateLabels(container);
    container.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        updateLabels(container);
      }
    });
  }

  function init() {
    document.querySelectorAll('variant-radios').forEach(attachToContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
